import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/ConsultingModule/ConsultingModule.tsx");
